
import TopbarTop from "../topbarTop/TopbarTop"
import TopbarMenuler from "../topbarMenuler/TopbarMenuler"
import styled from "styled-components"
import { useSelector } from "react-redux"

const Container = styled.div`
  margin-left: ${({sidebarState}) => sidebarState === "sm-icon" ? "85px" : sidebarState === "wide" ? "300px" : sidebarState === "hidden" && "0"};
  transition: .5s width;
  width: ${({sidebarState}) => sidebarState === "sm-icon" ? "calc(100% - 85px)" : sidebarState === "wide" ? "calc(100% - 300px)" : sidebarState === "hidden" && "100%"};
  position: fixed;
  top: 0;
  z-index: 10;
  background-color: ${({ theme }) => theme.mainBgColor};
 

`
const Topbar = () => {

  const {sidebarState, topStagesState} = useSelector(state => state.layout)

  return (
    <Container sidebarState={sidebarState}>
      <TopbarTop />
      {
        topStagesState &&
        <TopbarMenuler/>
      }
    </Container>
  )
}

export default Topbar





// import TopbarTop from "./topbarTop/TopbarTop"
// import TopbarMenuler from "./topbarMenuler/TopbarMenuler"
// import styled from "styled-components"
// import { useDispatch } from "react-redux"
// import { hamburgerMenuActive } from "../../../features/layout/layoutSlice"
// import { useSelector } from "react-redux"

// const Container = styled.div`
//   width: calc(100% - 300px);
//   margin-left: 300px;
//   position: fixed;
//   top: 0;
//   z-index: 10;
//   background-color: ${({ theme }) => theme.mainBgColor};
 

// `
// const Topbar = () => {

//   return (
//     <Container>
//         <TopbarTop />
//         <TopbarMenuler/>
//     </Container>
//   )
// }

// export default Topbar